/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a sequence above to see its GC content.`)
};

const es_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia arriba para ver su contenido GC.`)
};

const de_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben eine Sequenz ein, um ihren GC-Gehalt zu sehen.`)
};

const nl_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een sequentie om het GC-gehalte te zien.`)
};

const fr_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence ci-dessus pour voir son contenu GC.`)
};

const it_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza sopra per vedere il suo contenuto GC.`)
};

const pt_br2_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência acima para ver seu conteúdo GC.`)
};

const pt_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência acima para ver o seu conteúdo GC.`)
};

const ja_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上に配列を貼り付けるとGC含量が表示されます。`)
};

const zh_gc_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴序列以查看其 GC 含量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_hint_empty", locale)
	if (locale === "en") return en_gc_hint_empty(inputs)
	if (locale === "es") return es_gc_hint_empty(inputs)
	if (locale === "de") return de_gc_hint_empty(inputs)
	if (locale === "nl") return nl_gc_hint_empty(inputs)
	if (locale === "fr") return fr_gc_hint_empty(inputs)
	if (locale === "it") return it_gc_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_gc_hint_empty(inputs)
	if (locale === "pt") return pt_gc_hint_empty(inputs)
	if (locale === "ja") return ja_gc_hint_empty(inputs)
	return zh_gc_hint_empty(inputs)
};